<h5 class="title-h5 text-center mb-12">{{ "public_login_title" | translate }}</h5>
<form [formGroup]="loginForm" (ngSubmit)="login()">
    <input type="text" appAutofocus formControlName="email" pInputText class="w-full" placeholder="{{ 'public_login_email' | translate }}" required />

    @if (emailControl.invalid && displayValidationMessages) {
        <div class="flex flex-col field p-fluid mt-3">
            @if (emailControl.errors?.["required"]) {
                <p-message class="mb-1" severity="error">{{ "standard_email_required" | translate }}</p-message>
            } @else if (emailControl.errors?.["email"]) {
                <p-message class="mb-1" severity="error">{{ "standard_email_validation_error" | translate }}</p-message>
            }
        </div>
    }

    <p-password
        formControlName="password"
        [feedback]="false"
        [toggleMask]="true"
        inputId="password"
        class="w-full mt-4"
        placeholder="{{ 'public_login_password' | translate }}"
        required
    />

    <div class="my-8 flex items-center justify-between">
        <div class="flex items-center gap-2">
            <!--
            <p-checkbox inputId="remember" formControlName="remember" [binary]="true" />
            <label for="remember" class="body-small">Remember me</label>
             -->
        </div>
        <a routerLink="/lost-password" class="body-small hover:underline text-blue-logo">
            {{ "public_login_password_forgot" | translate }}
        </a>
    </div>
    <button pButton type="submit" class="body-button w-full p-button-blue-logo">{{ "public_login_button" | translate }}</button>
</form>
<div class="mt-16 body-small text-center">
    {{ "public_login_no_account_text" | translate }}
    <a class="text-blue-logo hover:underline" routerLink="/register">{{ "public_login_register_link" | translate }}</a>
</div>
